import { createStore } from 'satcheljs';
export default createStore('optionsSearchStore', {
    query: '',
    suppressFailedSearchDatapoints: false,
});
//# sourceMappingURL=store.js.map